module.exports = __webpack_public_path__ + "img/error400-cover.b10769d6.png";